export default __webpack_public_path__ + "img/filter_OL.298711fbee792118901d382512c50367.jpg";